module.exports = __webpack_public_path__ + "static/media/livestock_output_1.c96b1bca.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/LivestockIdxTool/livestock_output_1.png
// module id = 1789
// module chunks = 0